/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import type { DdpFieldsBelowFoldFragment } from 'bundles/degree-description/__generated__/contentfulTypes';
import { EventCard } from 'bundles/degree-description/components/modules/events/EventCard';
import { useDegreeDescriptionPageTheme } from 'bundles/degree-description/degreeDescriptionPageTheme';
import { useDegreeDescriptionEventingContext } from 'bundles/degree-description/providers/DegreeDescriptionEventingProvider';
import Container from 'bundles/premium-hub/components/shared/Container';

import _t from 'i18n!nls/degree-description';

export type EventCollectionType = NonNullable<DdpFieldsBelowFoldFragment['upcomingEventsCollection']>['items'];

type Props = {
  events: EventCollectionType;
};

const styles = {
  wrapper: css`
    padding: var(--cds-spacing-600) 0;
  `,
  padding: css`
    margin-bottom: var(--cds-spacing-300);
    padding-top: 0;
  `,
};

const EventsSection: React.FC<Props> = ({ events }) => {
  const theme = useDegreeDescriptionPageTheme();
  const { useGetViewPageSectionRef } = useDegreeDescriptionEventingContext();
  const pageSectionRef = useGetViewPageSectionRef('events');

  return (
    <div css={styles.wrapper} ref={pageSectionRef}>
      <Container>
        <Typography2 variant="titleSmall" component="h2" css={[styles.padding, theme.mobileFontSizeStyle?.header]}>
          {_t('Events')}
        </Typography2>
        <Grid container spacing={32}>
          {events.map((event) => {
            if (!event) return null;
            const {
              eventDate,
              recurrenceFrequency,
              eventDescription,
              ctaTitle,
              ctaUrl,
              sys: { id: eventId },
            } = event;
            if (!eventDate && !recurrenceFrequency) return null;
            return (
              <EventCard
                key={`event-${eventId}`}
                eventDate={eventDate}
                recurrenceFrequency={recurrenceFrequency}
                eventDescription={eventDescription}
                ctaTitle={ctaTitle}
                ctaUrl={ctaUrl}
              />
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

export default EventsSection;
